"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
function FormSwitch(props) {
    let value = false;
    if (props.value === "1") {
        value = true;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.FormGroup, { className: "switch" },
            react_1.default.createElement(Form_1.default.Check, { type: "switch", id: props.id, name: props.name, label: props.label, disabled: props.disabled, value: value, checked: props.checked, defaultChecked: props.value, onChange: props.onChange }),
            react_1.default.createElement("div", { className: "note" }, props.note),
            react_1.default.createElement("div", { className: "d-flex align-items-center gap-1" },
                props.link && react_1.default.createElement("a", { href: props.link, className: "note", target: "_blank" }, props.textLink),
                props.link1 && react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", null, "-"),
                    react_1.default.createElement("a", { href: props.link1, className: "note", target: "_blank" }, props.textLink1)),
                props.link2 && react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", null, "-"),
                    react_1.default.createElement("a", { href: props.link2, className: "note", target: "_blank" }, props.textLink2))))));
}
exports.default = FormSwitch;
